module.exports = __webpack_public_path__ + "static/media/c93deb4a.jpg";